export default function CareersPage() {
  return (
    <div className="bg-background min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <h1 className="text-4xl font-bold text-text-primary mb-6">Join Our Team</h1>
        <p className="text-xl text-text-secondary max-w-2xl mx-auto mb-12">
          We are always looking for passionate educators, content creators, and developers to join our mission of transforming competitive exam preparation.
        </p>

        <div className="bg-bg-secondary p-12 rounded-2xl border border-border inline-block">
          <h2 className="text-2xl font-bold text-text-primary mb-4">No Open Positions Currently</h2>
          <p className="text-text-secondary mb-8">
            We don't have any specific openings right now, but we love hearing from talented individuals.
          </p>
          <a
            href="mailto:careers@rohithsacademy.com"
            className="px-8 py-3 rounded-lg bg-primary text-white font-semibold hover:bg-primary-dark transition-smooth"
          >
            Send us your Resume
          </a>
        </div>
      </div>
    </div>
  );
}

